import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    baseInfo: {},
    memberBonusFlowInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        list: []
    },
    orderInfo: { // 交易记录
        pageNum: 1,
        pageSize: 10,
        total: 0,
        list: []
    },
    receiveAddressInfo: { // 收货地址
        pageNum: 1,
        pageSize: 10,
        total: 0,
        list: []
    },
    logInfo: { // 等录日志
        pageNum: 1,
        pageSize: 10,
        total: 0,
        list: []
    }
}

const reducers = createActions({
    getUserDetailAction: {
        success: (state, action) => ({
            ...state,
	        baseInfo: action.payload
        })
    },
    // getMemberBonusFlowAction: {
    //     success: (state, action) => {
    //         const { pageNum, total, list } = action.payload
    //         return {
    //             ...state,
    //             memberBonusFlowInfo: {
    //                 ...state.memberBonusFlowInfo,
    // 	            pageNum,
    // 	            total,
    // 	            list
    //             }
    //         }
    //     }
    // },
    getOrderListAction: {
        success: (state, action) => {
	        const { pageNum, total, list } = action.payload
	        return {
		        ...state,
		        orderInfo: {
			        ...state.orderInfo,
			        pageNum,
			        total,
			        list
		        }
	        }
        }
    },
    getReceiveAddressAction: {
        success: (state, action) => {
            const { pageNum, total, list } = action.payload
            return {
                ...state,
	            receiveAddressInfo: {
                    ...state.receiveAddressInfo,
                    pageNum: pageNum || 1,
                    total: total || 0,
                    list
                }
            }
        }
    }
    // getLoginLogListAction: {
    //     success: (state, action) => {
    //         const { pageNum, total, list } = action.payload
    //         return {
    // 	        ...state,
    // 	        logInfo: {
    // 		        ...state.logInfo,
    // 		        pageNum,
    // 		        total,
    // 		        list
    // 	        }
    //         }
    //     }
    // }
}, actions)

const customerSlice = createSlice({
    name: 'customerDetail',
    initialState,
    ...reducers
})

export default customerSlice
